
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fullcoveragewarranty/privacy-policy",
      function () {
        return require("private-next-pages/fullcoveragewarranty/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fullcoveragewarranty/privacy-policy"])
      });
    }
  